import fetch from 'isomorphic-fetch';
import moment from 'moment';
import { setAllStorage } from '../util/storage';
import * as ActionType from './types/AuthActionTypes';
import { getUserContext, identifyUser, identifyUserSailthru } from './UserActions';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

// checks the reason from backend, and retuns a more specific error message
// or if reason doesn't exist, sends the message that comes from backend, or default error message
function getDetailedMessage(error) {
  const defaultErrorMessage = 'There was a problem processing your request. Please try again or contact customer support for assistance.';
  let errorMessage;

  switch (error.category.reason) {
    case 'invalid_password':
      errorMessage = 'Your email and password do not match.';
      break;
    case 'invalid_email':
      errorMessage = 'You have entered an invalid email.';
      break;
    case 'not-found':
      errorMessage = 'You have entered an invalid email.';
      break;
    case 'user_locked':
      errorMessage = 'Looks like you have forgotten your password. Please click the forgot password link above to reset your password and continue.';
      break;
    case 'facebook-missing-email':
      errorMessage = 'You must provide Zola access to your Facebook email address to create or access your account.';
      break;
    default:
      errorMessage = defaultErrorMessage;
      break;
  }

  return errorMessage;
}

function checkResponse(response) {
  if (response.status === 'error') {
    const error = new Error(response.message);
    error.response = response;
    error.detailedMessage = getDetailedMessage(response);
    throw error;
  }
  return response;
}

function loginSuccess(email) {
  return {
    type: ActionType.LOGIN_SUCCESS,
    payload: { email }
  };
}

export function loginFailure(error) {
  return {
    type: ActionType.LOGIN_FAILURE,
    payload: {
      status: error.response.status,
      statusText: error.response.statusText
    }
  };
}

export function loginRequest() {
  return {
    type: ActionType.LOGIN_REQUEST
  };
}

export function logout() {
  return {
    type: ActionType.LOGOUT
  };
}

export function setBusinessUnit(businessUnit) {
  return {
    type: ActionType.SET_BUSINESS_UNIT,
    payload: businessUnit
  };
}

export function login(loginFormRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/auth/login',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginFormRequest)
      })
      .then(res => res.json(res))
      .then(checkResponse) // Error Handling
      .then((responseJson) => {
        dispatch(loginSuccess(loginFormRequest.email));
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
        return responseJson;
      })
      .then(responseJson => identifyUserSailthru(loginFormRequest.email).then(() => responseJson));
  };
}

export function facebookLogin(fbLoginRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/auth/facebook-login',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(fbLoginRequest)
      })
      .then(res => res.json(res))
      .then(checkResponse) // Error Handling
      .then((responseJson) => {
        dispatch(loginSuccess(fbLoginRequest.email));
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
        return responseJson;
      })
      .then(responseJson => identifyUserSailthru(fbLoginRequest.email).then(() => responseJson));
  };
}

export function signout() {
  return dispatch => (
    fetch('/web-api/v1/auth/signout',
      {
        credentials: 'same-origin',
      })
      .then(dispatch(logout()))
  );
}

export function signup(createUserRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/user/create',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(createUserRequest)
      })
      .then(res => res.json(res))
      .then(checkResponse) // Error Handling
      .then(() => {
        setAllStorage('zolaUserCreatedAt', moment().toISOString());
        dispatch(loginSuccess(createUserRequest.email));
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
      })
      .then(() => identifyUserSailthru(createUserRequest.email))
      .catch((error) => {
        throw error;
      });
  };
}

export function checkEmail(email) {
  return () => (
    fetch(`/web-api/v1/user/email_available/${email}`,
      {
        method: 'POST',
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
  );
}

export function sendResetPassword(email) {
  return () => (
    fetch(`/web-api/v1/user/reset_password/${email}`,
      {
        method: 'POST',
        credentials: 'same-origin',
      })
      .then(res => res.json(res))
      .then(checkResponse) // Error Handling
  );
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js